import React from 'react';
import DENTTooth from '../Tooth/DENTTooth';
import styles from './DENTJaw.module.scss';
import { Jaw } from '../../Interfaces/Jaw.interface';
import { ToothView } from '../../Enums/ToothView.enum';
import { Scale } from '../../../Base/Interfaces/Scale.interface';
import { Tooth } from '../../../../graphql/graphql';

interface Props {
	data: Jaw;
	views: ToothView[];
	scale: Scale;
	reverse?: boolean;
	showToothPeriodontal?: boolean;
	onToothClick: (tooth: Tooth) => void;
	showToothEndodontic: boolean;
}

const DENTJaw: React.FC<Props> = ({
	data,
	views,
	reverse,
	scale,
	showToothPeriodontal,
	onToothClick,
	showToothEndodontic = true,
}) => {
	return (
		<div className={styles.wrapper}>
			{(Object.keys(data) as (keyof Jaw)[]).map(toothKey => {
				const toothData = data[toothKey];
				return (
					<div onClick={() => onToothClick(toothData)} key={toothKey}>
						<DENTTooth
							data={toothData}
							views={views}
							reverse={reverse}
							scale={scale}
							showToothPeriodontal={showToothPeriodontal}
							showToothEndodontic={showToothEndodontic}
							isDetail={false}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default DENTJaw;
